import { useTranslation } from "react-i18next";

interface FreeTextStepProps {
  value: string;
  onChange: (v: string) => void;
}

export function FreeTextStep({ value, onChange }: FreeTextStepProps) {
  const { t } = useTranslation();
  return (
    <div className="card md:max-w-wizard">
      <h2 className="font-display text-h3 text-ink">{t("q.free_text._label")}</h2>
      <p className="mt-2 text-caption text-muted">{t("q.free_text._help")}</p>
      <textarea
        value={value}
        onChange={(e) => onChange(e.target.value.slice(0, 500))}
        placeholder={t("q.free_text._placeholder")}
        className="input mt-6 min-h-32 resize-none"
        maxLength={500}
      />
      <p className="mt-1 text-right text-caption text-muted">{value.length} / 500</p>
    </div>
  );
}
